var exports = {
  "k": "x0a7806d5--e20837--container",
  "A": "x0a7806d5--e20837--item",
};

module.exports = exports;
